var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 76,
    viewBox: "0 0 78 76",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4412 39.9533C12.0726 29.5588 13.4891 23.843 21.9338 15.0632L21.0647 13.5634C19.8521 11.4708 20.5717 8.79503 22.672 7.58688C24.7722 6.37873 27.4578 7.09571 28.6704 9.1883L29.5395 10.6882C41.3933 7.79143 47.0698 9.4271 54.4205 17.531L64.1254 34.2789C67.6653 34.3769 69.5808 35.2658 71.1145 37.3656C72.4693 39.2205 71.5258 41.7748 69.5318 42.9218L29.9554 65.6876C27.9614 66.8347 25.2694 66.3716 24.3346 64.2752C23.2762 61.9019 23.4613 59.8046 25.1461 56.7012L15.4412 39.9533Z",
    stroke: "#E5E5E5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.75 62.894C44.5091 68.0943 49.725 62.9813 48.5987 55L34.75 62.894Z",
    stroke: "#E5E5E5",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.471 19C18.9821 26.9512 18.0581 31.6365 22.471 40.5",
    stroke: "#E5E5E5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 28.25,
    cy: 74.5,
    r: 1.5,
    fill: "#959595"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 62.75,
    cy: 8,
    r: 1,
    fill: "#959595"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 42.25,
    cy: 1.5,
    r: 1.5,
    fill: "#959595"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 2.75,
    cy: 38,
    r: 2.5,
    fill: "#959595"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 73.75,
    cy: 54,
    r: 1,
    fill: "#959595"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 7.75,
    cy: 16,
    r: 1,
    fill: "#959595"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 8.75,
    cy: 58,
    r: 1,
    fill: "#959595"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 75.75,
    cy: 25,
    r: 2,
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotifications);
export default __webpack_public_path__ + "static/media/NoNotifications.6704fac9a4e342202a9a9f4ba22bc976.svg";
export { ForwardRef as ReactComponent };